import { createReducer, on } from '@ngrx/store';
import { 
  SUBCATEGORY_FIND_ALL_SUCCESS,
  SUBCATEGORY_FIND_SUCCESS,
  SUBCATEGORY_FAILED,
  SUBCATEGORY_UPDATE_LOADING,
  SUBCATEGORY_UPDATE_ID,
  SUBCATEGORY_CLEAR_STATE
} from '../actions'
import { Subcategory } from '@core/models';

export interface SubcategoryState {
  loading: boolean;
  subcategoryList: Subcategory[] | null;
  subcategory: Subcategory | null;
  error: string | null;
  subcategoryId: string | null;
}

const initialState: SubcategoryState = {
  loading: false,
  subcategoryList: null,
  subcategoryId: null,
  error: null,
  subcategory: null,
}

export const subcategoryReducer = createReducer(
  initialState,
  on(SUBCATEGORY_FIND_ALL_SUCCESS, (state, { subcategoryList }) => ({ ...state, subcategoryList })),
  on(SUBCATEGORY_UPDATE_ID, (state, { subcategoryId }) => ({ ...state, subcategoryId })),
  on(SUBCATEGORY_FAILED, (state, { error }) => ({ ...state, error })),
  on(SUBCATEGORY_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(SUBCATEGORY_FIND_SUCCESS, (state, { subcategory }) => ({ ...state, subcategory })),
  on(SUBCATEGORY_CLEAR_STATE, () => ({ ...initialState })),
);
